var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data_content",staticStyle:{"padding-top":"0"}},[_vm._v("\n  功能待开发...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }